import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { HiLocationMarker } from "react-icons/hi";
import { AiOutlineMail } from "react-icons/ai";
import { FiPhoneCall } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import axios from "axios";


const UserForm = ({ open, setOpen }) => {
  
 const [profileImage, setProfileImage] = useState(null);
 const [uploadCv, setUploadCv] = useState(null);
 const [previewUrl, setPreviewUrl] = useState('');
 const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    contact: '',
    location: '',
    about: '',
    jobTitle: '',
    profileUrl: ''
 });

 useEffect(() => {
    const fetchUserData = async () => {
      const token = window.localStorage.getItem('token');
      if (token) {
        const decoded = jwtDecode(token);

        const userId = decoded.userId;
        try {
          const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-user/${userId}`);
          setFormData(response.data.user); // Set fetched user data
          setProfileImage(response.data.profileImage);
          setUploadCv(response.data.cv);
        } catch (err) {
          console.error(err);
        }
      }
    };

    fetchUserData();
 }, []);

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    console.log(previewUrl);
 };

 const handleLogoChange = (e) => {
    const file = e.target.files[0];
    
    setProfileImage(file);
    // Generate a preview URL for the selected image
    const previewUrl = URL.createObjectURL(file);
    setPreviewUrl(previewUrl);
    console.log(previewUrl);
 };

 const submithandle = async (e) => {
    e.preventDefault();
    try {
      const token = window.localStorage.getItem('token');
      const decoded = jwtDecode(token);
      const userId = decoded.userId;

      const formData = new FormData();
      // Append text inputs
      Object.keys(formData).forEach(key => formData.append(key, formData[key]));
      // Append file inputs
      if (profileImage) {
        formData.append("profileImage", profileImage);
      }
      if (uploadCv) {
        formData.append("cv", uploadCv);
      }

      const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/user/update-user/${userId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data);
    } catch (err) {
      console.error(err);
    }
 };

 const closeModal = () => setOpen(false);

  return (
    <>
      <Transition appear show={open ?? false} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <Dialog.Title
                    as='h3'
                    className='text-lg font-semibold leading-6 text-gray-900'
                  >
                    Edit Profile
                  </Dialog.Title>
                  <form
 className='w-full mt-2 flex flex-col gap-5'
 onSubmit={submithandle}
>
 {/* Text Inputs */}
 <div className='w-full flex gap-2'>
    <div className='w-1/2'>
      <label htmlFor='firstName' className='text-gray-600 text-sm mb-1'>
        First Name
      </label>
      <input
        type='text'
        id='firstName'
        name='firstName'
        placeholder='First Name'
        value={formData.firstName}
        onChange={handleInputChange}
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
    <div className='w-1/2'>
      <label htmlFor='lastName' className='text-gray-600 text-sm mb-1'>
        Last Name
      </label>
      <input
        type='text'
        id='lastName'
        name='lastName'
        placeholder='Last Name'
        value={formData.lastName}
        onChange={handleInputChange}
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
 </div>

 <div className='w-full flex gap-2'>
    <div className='w-1/2'>
      <label htmlFor='contact' className='text-gray-600 text-sm mb-1'>
        Contact
      </label>
      <input
        type='text'
        id='contact'
        name='contact'
        placeholder='Contact'
        value={formData.contact}
        onChange={handleInputChange}
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
    <div className='w-1/2'>
      <label htmlFor='location' className='text-gray-600 text-sm mb-1'>
        Location
      </label>
      <input
        type='text'
        id='location'
        name='location'
        placeholder='Location'
        value={formData.location}
        onChange={handleInputChange}
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
 </div>

 <div className='w-full flex gap-2'>
    <div className='w-full'>
      <label htmlFor='jobTitle' className='text-gray-600 text-sm mb-1'>
        Job Title
      </label>
      <input
        type='text'
        id='jobTitle'
        name='jobTitle'
        placeholder='Job Title'
        value={formData.jobTitle}
        onChange={handleInputChange}
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
 </div>

 <div className='w-full flex gap-2 text-sm'>
    <div className='w-1/2'>
      <label htmlFor='profileImage' className='text-gray-600 text-sm mb-1'>
        Profile Picture
      </label>
      <input
        type='file'
        id='profileImage'
        name='profileImage'
        onChange={handleLogoChange}
        required
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>

    <div className='w-1/2'>
      <label htmlFor='cv' className='text-gray-600 text-sm mb-1'>
        Resume
      </label>
      <input
        type='file'
        id='cv'
        name='cv'
        className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      />
    </div>
 </div>

 <div className='flex flex-col'>
    <label htmlFor='about' className='text-gray-600 text-sm mb-1'>
      About
    </label>
    <textarea
      id='about'
      name='about'
      placeholder='About'
      value={formData.about}
      onChange={handleInputChange}
      className='mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500'
      rows={4}
    ></textarea>
 </div>

 <div className='mt-4'>
    <button
      type='submit'
      className='inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-8 py-2 text-sm font-medium text-white hover:bg-[#1d4fd846] hover:text-[#1d4fd8] focus:outline-none '
    >
      Submit
    </button>
 </div>
</form>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

const UserProfile = () => {
  const token = window.localStorage.getItem('token');
  const [userInfo , setUserInfo] = useState('');
  

  useEffect(() => {
    if (token) {
       const fetchUserData = async () => {
         try {
           const decoded = jwtDecode(token);
           const userId = decoded.userId;
           console.log(userId);
           const response = await axios.get(`http://localhost:8800/user/get-user/${userId}`);
           setUserInfo(response.data.user);
           console.log(response.data.user);
         } catch (err) {
           console.log(err);
         }
       };
   
       fetchUserData();
    }
   }, [token]);
   
  

  const [open, setOpen] = useState(false);
  
  console.log(userInfo);

  return (
    <div className='container mx-auto flex items-center justify-center py-10'>
      <div className='w-full md:w-2/3 2xl:w-2/4 bg-white shadow-lg p-10 pb-20 rounded-lg'>
        <div className='flex flex-col items-center justify-center mb-4'>
          <h1 className='text-4xl font-semibold text-slate-600'>
            {userInfo?.firstName + " " + userInfo?.lastName}
          </h1>

          <h5 className='text-blue-700 text-base font-bold'>
            {userInfo?.jobTitle || "Add Job Title"}
          </h5>

          <div className='w-full flex flex-wrap lg:flex-row justify-between mt-8 text-sm'>
            <p className='flex gap-1 items-center justify-center  px-3 py-1 text-slate-600 rounded-full'>
              <HiLocationMarker /> {userInfo?.location ?? "No Location"}
            </p>
            <p className='flex gap-1 items-center justify-center  px-3 py-1 text-slate-600 rounded-full'>
              <AiOutlineMail /> {userInfo?.email ?? "No Email"}
            </p>
            <p className='flex gap-1 items-center justify-center  px-3 py-1 text-slate-600 rounded-full'>
              <FiPhoneCall /> {userInfo?.contact ?? "No Contact"}
            </p>
          </div>
        </div>

        <hr />

        <div className='w-full py-10'>
          <div className='w-full flex flex-col-reverse md:flex-row gap-8 py-6'>
            <div className='w-full md:w-2/3 flex flex-col gap-4 text-lg text-slate-600 mt-20 md:mt-0'>
              <p className='text-[#0536e7]  font-semibold text-2xl'>ABOUT</p>
              <span className='text-base text-justify leading-7'>
                {userInfo?.about ?? "No About Found"}
              </span>
            </div>

            <div className='w-full md:w-1/3 h-44'>
              <img
                src={userInfo?.profileUrl}
                alt={userInfo?.firstName}
                className='w-full h-48 object-contain rounded-lg'
              />
              <button
                className='w-full md:w-64 bg-blue-600 text-white mt-4 py-2 rounded'
                onClick={() => setOpen(true)}
              >
                Edit Profile
              </button>
            </div>
          </div>
        </div>
      </div>

      <UserForm open={open} setOpen={setOpen} />
    </div>
  );
};

export default UserProfile;
